import { useNavigate, useParams } from "react-router-dom";
import { PageService } from "../../Services/Axios/Api";
import { useEffect, useState } from "react";
import "./PagePreview.css";
import { getComponent } from "../../ComponentsMap";
import { Spinner } from "react-bootstrap";
import 'quill/dist/quill.snow.css';

const Page = ({id , isHomePage}) => {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchPage = async () => {
            try {
                if(isHomePage){
                    var response = await PageService.GetPageByIdAndLanguage(id , localStorage.getItem('selectedLanguage'));

                }else{
                    var response = await PageService.GetPageBySlugAndLanguage(slug , localStorage.getItem('selectedLanguage'));

                }

                response.result.pageComponents.sort((a, b) => a.order - b.order);
                if (!response.isSuccess) {
                    navigate('/notfound');
                    return;
                }
                setPage(response.result);
            } catch (error) {
                setError(error);
                navigate('/notfound');
            } finally {
                setLoading(false);
            }
        };
        fetchPage();
    }, [slug]);
    const ConvertData = (data) => {
        return JSON.parse(data);
    }
    return (
        <div>
            {loading && <Spinner animation="border" />}
            {page &&
                <>
                    {page?.isTitleVisible && page?.title && (
                        <section className="PageTitleSection">
                                <h1 className="text-center">{page?.title}</h1>
                            </section>
                    )}
                    <section className="PageContentSection">
                        {page?.pageComponents?.map(component => (
                            <div key={component.id} className="">
                                {getComponent(component.component.componentName, ConvertData(component.component.data))}
                            </div>
                        ))}             
                    </section>
                </>
            }
        </div>
    )
}

export default Page;